import React from "react";

export default function ResearchCompare() {
  return (
    <section
      id="research-and-compare"
      className="max-w-5xl mx-auto py-12 px-4"
      aria-labelledby="research-compare-title"
    >
      <header className="text-center mb-10">
        <h2
          id="research-compare-title"
          className="text-2xl md:text-3xl font-bold text-gray-900"
        >
          3. Research and Compare
        </h2>
        <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
          Don&apos;t rush into signing up. Take the time to evaluate your options carefully to find a personal trainer who meets your needs.
        </p>
      </header>

      <article className="space-y-8 text-gray-800 leading-relaxed">
        <section>
          <h3 className="text-xl font-semibold mb-3">Trainer Qualifications</h3>
          <p>
            Look for certifications from reputable organizations like{" "}
            <a
              href="https://www.acsm.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-600 underline hover:text-amber-700"
            >
              ACSM (American College of Sports Medicine)
            </a>
            ,{" "}
            <a
              href="https://www.nsca.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-600 underline hover:text-amber-700"
            >
              NSCA (National Strength and Conditioning Association)
            </a>
            , or{" "}
            <a
              href="https://www.acefitness.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-amber-600 underline hover:text-amber-700"
            >
              ACE (American Council on Exercise)
            </a>
            . These certifications indicate the trainer&apos;s expertise and adherence to high professional standards.
          </p>
        </section>

        <section>
            <h3 className="text-xl font-semibold mb-3">Trainer Experience</h3>
            <p>
                If your fitness goals are specialized, such as post-injury rehabilitation or marathon training, ensure your trainer has relevant experience in those areas. Experienced trainers bring valuable insights and customized programs that help you achieve your goals safely and effectively.
            </p>
            <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5 mt-8'>
                <div className='md:col-span-1 p-2 flex justify-center items-center'>
                    <h4 className='text-base uppercase'><strong>Beginner trainer for Basic Goals</strong></h4>
                </div>
                <p className='md:col-span-3 py-2'>
                    When you want to get fit, improve cardiovascular function, lose some weight or feel healthy, you may not need to spend a lot on 
                    personal training sessions. These are trainers with 1 to 5 years of experience.
                </p> 
            </div>
            <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5'>
                <div className='md:col-span-1 p-2 flex justify-center items-center'>
                    <h4 className='text-base uppercase'><strong>Intermediate level trainer for Average Goals</strong></h4>
                </div>
                <p className='md:col-span-3 py-2'>
                    Get an intermediate level trainer to help you in getting the V-shape or the right curves. They will have 5 to 9 years of experience.
                </p> 
            </div>
            <div className='md:grid md:grid-cols-4 border border-slate-200 rounded-lg gap-5 p-5'>
                <div className='md:col-span-1 p-2 flex justify-center items-center'>
                    <h4 className='text-base uppercase'><strong>Elite coaches for Advanced Goals</strong></h4>
                </div>
                <p className='md:col-span-3 py-2'>
                    Need a complete transformation in terms of health and physical appearance? Get a advanced level trainer with 
                    more than 10 years of experience in the fitness industry.
                </p> 
            </div>   
        </section>

        <section>
          <h3 className="text-xl font-semibold mb-3">Client Testimonials</h3>
          <p>
            Reviews and testimonials from past clients provide social proof of a trainer’s effectiveness and professionalism. Check platforms like Google Reviews, Facebook, or dedicated fitness forums to read honest feedback and success stories.
          </p>
        </section>

        <section>
          <h3 className="text-xl font-semibold mb-3">Trial Sessions</h3>
          <p>
            Many personal trainers offer introductory or trial sessions for first-time clients. This allows you to experience their training style and see if it aligns with your preferences before making a longer-term commitment.
          </p>
        </section>
      </article>
    </section>
  );
}
